import { render } from "./Howtovote.vue?vue&type=template&id=be018952&scoped=true"
import script from "./Howtovote.vue?vue&type=script&lang=js"
export * from "./Howtovote.vue?vue&type=script&lang=js"

import "./Howtovote.vue?vue&type=style&index=0&id=be018952&lang=scss&scoped=true"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be018952"]])

export default __exports__